export default __webpack_public_path__ + "static/media/export-white.d07df0da.svg";